import type { FC } from 'react';

import { GenericButton } from '@shared/components/ui/custom';

interface FilteringModalErrorStateProps {
  refetch: () => void;
}

export const FilteringModalErrorState: FC<FilteringModalErrorStateProps> = ({ refetch }) => {
  return (
    <div
      className="flex flex-col items-center justify-center pt-10 pb-30"
      data-testid="filtering-modal-error-state-container"
    >
      <div className="flex flex-col items-center gap-3 text-center">
        <h2 className="text-2xl font-light text-foreground" data-testid="filtering-modal-error-state-title">
          Error fetching filters
        </h2>
        <div className="flex flex-col items-center gap-2">
          <GenericButton
            onClick={refetch}
            variant="link"
            className="text-sm text-primary hover:text-primary/80 transition-colors cursor-pointer bg-transparent border-none p-0 hover:no-underline"
            data-testid="filtering-modal-error-state-retry-button"
          >
            Retry
          </GenericButton>
        </div>
      </div>
    </div>
  );
};
